module.exports = __webpack_public_path__ + "img/water-softener-text.9a3952c2.svg";